<div class="min-h-screen bg-gray-50">
  <!-- Header -->
  <div class="bg-white border-b border-gray-200">
    <div class="w-full px-4 sm:px-6 lg:px-8 py-4">
      <div class="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
        <!-- Title Section -->
        <div class="flex-shrink-0">
          <h1 class="text-2xl sm:text-3xl font-bold text-gray-900 flex items-center gap-3">
            <i class="fa fa-exclamation-triangle text-blue-600 text-2xl"></i>
            Tableau de Bord des Écarts
          </h1>
          <p class="mt-1 text-sm text-gray-500">
            Suivi des écarts de caisse et stock par statut
          </p>
        </div>
        
        <!-- Controls Section -->
        <div class="w-full md:w-auto flex flex-col sm:flex-row sm:flex-wrap gap-4 md:gap-6">
          <div class="flex items-center gap-3 w-full sm:w-auto">
            <label class="text-sm font-medium text-gray-700 whitespace-nowrap">Période Rapide:</label>
            <select
              class="w-full sm:w-auto px-4 py-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 min-w-32"
              [value]="selectedRange"
              (change)="onRangeChange($any($event.target)?.value)">
              <option value="today">Aujourd'hui</option>
              <option value="week">7 Jours</option>
              <option value="month">Ce Mois</option>
              <option value="lastMonth">Mois Précédent</option>
              <option value="year">Cette Année</option>
            </select>
          </div>
          
          <div class="flex flex-col sm:flex-row items-start sm:items-center gap-3 w-full sm:w-auto">
            <label class="text-sm font-medium text-gray-700 whitespace-nowrap">Période Personnalisée:</label>
            <div class="flex flex-col sm:flex-row items-start sm:items-center gap-3 w-full sm:w-auto">
              <input type="date" [(ngModel)]="startDate" (change)="onCustomDateChange()" class="w-full sm:w-auto px-4 py-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500">
              <span class="text-sm text-gray-500">à</span>
              <input type="date" [(ngModel)]="endDate" (change)="onCustomDateChange()" class="w-full sm:w-auto px-4 py-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500">
            </div>
          </div>
          
          <button type="button" (click)="refresh()" [disabled]="isLoading" class="w-full sm:w-auto px-6 py-2 bg-blue-600 text-white text-sm rounded-lg hover:bg-blue-700 disabled:opacity-50 transition-colors flex items-center justify-center gap-2 whitespace-nowrap">
            <i class="fa" [class.fa-spinner]="isLoading" [class.fa-sync-alt]="!isLoading" [class.fa-spin]="isLoading"></i>
            <span>{{ isLoading ? 'Chargement...' : 'Actualiser' }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
    <!-- Loading State -->
    <div *ngIf="isLoading" class="flex items-center justify-center py-12">
      <div class="text-center">
        <i class="fa fa-spinner fa-spin text-4xl text-blue-600 mb-4"></i>
        <p class="text-gray-600">Chargement des données d'écarts...</p>
      </div>
    </div>

    <!-- Dashboard Content -->
    <div *ngIf="!isLoading">
    <!-- Summary Cards - Status Based -->
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
      <!-- Pending Total -->
      <div class="bg-white rounded-xl shadow-sm p-6 border border-gray-100 hover:shadow-lg transition-shadow duration-300">
        <div class="flex items-center justify-between">
          <div>
            <p class="text-sm font-medium text-gray-600">Total En Attente</p>
            <p class="text-2xl font-bold text-yellow-600">{{ pendingTotal | number:'1.2-2' }} MAD</p>
            <p class="text-xs text-gray-500 mt-1">Caisse: {{ pendingCash | number:'1.2-2' }} | Stock: {{ pendingStock | number:'1.2-2' }}</p>
          </div>
          <div class="w-12 h-12 bg-gradient-to-br from-yellow-500/20 to-yellow-600/20 rounded-full flex items-center justify-center border-2 border-yellow-500/30">
            <i class="fa fa-clock text-yellow-600 text-xl"></i>
          </div>
        </div>
      </div>

      <!-- Approved Total -->
      <div class="bg-white rounded-xl shadow-sm p-6 border border-gray-100 hover:shadow-lg transition-shadow duration-300">
        <div class="flex items-center justify-between">
          <div>
            <p class="text-sm font-medium text-gray-600">Total Approuvé</p>
            <p class="text-2xl font-bold text-green-600">{{ approvedTotal | number:'1.2-2' }} MAD</p>
            <p class="text-xs text-gray-500 mt-1">Caisse: {{ approvedCash | number:'1.2-2' }} | Stock: {{ approvedStock | number:'1.2-2' }}</p>
          </div>
          <div class="w-12 h-12 bg-gradient-to-br from-green-500/20 to-green-600/20 rounded-full flex items-center justify-center border-2 border-green-500/30">
            <i class="fa fa-check-circle text-green-600 text-xl"></i>
          </div>
        </div>
      </div>

      <!-- Rejected Total -->
      <div class="bg-white rounded-xl shadow-sm p-6 border border-gray-100 hover:shadow-lg transition-shadow duration-300">
        <div class="flex items-center justify-between">
          <div>
            <p class="text-sm font-medium text-gray-600">Total Rejeté</p>
            <p class="text-2xl font-bold text-red-600">{{ rejectedTotal | number:'1.2-2' }} MAD</p>
            <p class="text-xs text-gray-500 mt-1">Caisse: {{ rejectedCash | number:'1.2-2' }} | Stock: {{ rejectedStock | number:'1.2-2' }}</p>
          </div>
          <div class="w-12 h-12 bg-gradient-to-br from-red-500/20 to-red-600/20 rounded-full flex items-center justify-center border-2 border-red-500/30">
            <i class="fa fa-times-circle text-red-600 text-xl"></i>
          </div>
        </div>
      </div>
    </div>

    <!-- Grand Total Card -->
    <div class="mb-8">
      <div class="bg-gradient-to-r from-blue-600 to-indigo-600 rounded-xl shadow-lg p-6 text-white">
        <div class="flex items-center justify-between">
          <div>
            <p class="text-sm font-medium text-blue-100">Total Général des Écarts</p>
            <p class="text-4xl font-bold mt-2">{{ grandTotal | number:'1.2-2' }} MAD</p>
            <p class="text-xs text-blue-100 mt-2">Tous les statuts confondus (Caisse + Stock)</p>
          </div>
          <div class="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center border-2 border-white/40">
            <i class="fa fa-chart-pie text-white text-2xl"></i>
          </div>
        </div>
      </div>
    </div>

    <!-- Charts Grid -->
    <div class="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-12">
      <!-- Global status evolution (pending/approved + grand total) -->
      <div class="bg-white rounded-xl shadow-lg p-6 border border-gray-100 hover:shadow-xl transition-shadow duration-300">
        <div class="flex items-center gap-3 mb-6">
          <div class="w-10 h-10 bg-gradient-to-br from-blue-500/20 to-blue-600/20 rounded-full flex items-center justify-center border-2 border-blue-500/30">
            <i class="fa fa-chart-line text-blue-600 text-lg"></i>
          </div>
          <h3 class="text-lg font-semibold text-gray-900">Évolution Globale par Statut</h3>
        </div>
        <div class="h-80">
          <canvas baseChart [data]="combinedEvolutionData" [options]="combinedEvolutionOptions" [type]="'line'"></canvas>
        </div>
      </div>

      <!-- Discrepancy by Product -->
      <div class="bg-white rounded-xl shadow-lg p-6 border border-gray-100 hover:shadow-xl transition-shadow duration-300">
        <div class="flex items-center gap-3 mb-6">
          <div class="w-10 h-10 bg-gradient-to-br from-blue-500/20 to-blue-600/20 rounded-full flex items-center justify-center border-2 border-blue-500/30">
            <i class="fa fa-tags text-blue-600 text-lg"></i>
          </div>
          <h3 class="text-lg font-semibold text-gray-900">Top 10 Produits - Écarts en Quantité</h3>
        </div>
        <div class="h-80">
          <canvas baseChart [data]="productDiscrepancyData" [options]="productDiscrepancyOptions" [type]="'bar'"></canvas>
        </div>
      </div>
    </div>
    <!-- Dedicated Cash and Stock evolution with totals -->
    <div class="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-12">
      <!-- Cash evolution -->
      <div class="bg-white rounded-xl shadow-lg p-6 border border-gray-100 hover:shadow-xl transition-shadow duration-300">
        <div class="flex items-center gap-3 mb-6">
          <div class="w-10 h-10 bg-gradient-to-br from-blue-500/20 to-blue-600/20 rounded-full flex items-center justify-center border-2 border-blue-500/30">
            <i class="fa fa-coins text-blue-600 text-lg"></i>
          </div>
          <h3 class="text-lg font-semibold text-gray-900">Évolution Caisse (avec Total)</h3>
        </div>
        <div class="h-80">
          <canvas baseChart [data]="cashEvolutionData" [options]="cashEvolutionOptions" [type]="'line'"></canvas>
        </div>
      </div>

      <!-- Stock evolution -->
      <div class="bg-white rounded-xl shadow-lg p-6 border border-gray-100 hover:shadow-xl transition-shadow duration-300">
        <div class="flex items-center gap-3 mb-6">
          <div class="w-10 h-10 bg-gradient-to-br from-yellow-500/20 to-yellow-600/20 rounded-full flex items-center justify-center border-2 border-yellow-500/30">
            <i class="fa fa-boxes text-yellow-600 text-lg"></i>
          </div>
          <h3 class="text-lg font-semibold text-gray-900">Évolution Stock (avec Total)</h3>
        </div>
        <div class="h-80">
          <canvas baseChart [data]="stockEvolutionData" [options]="stockEvolutionOptions" [type]="'line'"></canvas>
        </div>
      </div>
    </div>
  </div>
</div>